import { render, staticRenderFns } from "./ssqy.vue?vue&type=template&id=48bfb1cc&scoped=true"
import script from "./ssqy.vue?vue&type=script&lang=js"
export * from "./ssqy.vue?vue&type=script&lang=js"
import style0 from "./ssqy.vue?vue&type=style&index=0&id=48bfb1cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bfb1cc",
  null
  
)

export default component.exports